(function () {
  var stylesheet = document.getElementById('NativeCookieBannerStylesheet');

  function activateStylesheet() {
    if (stylesheet) stylesheet.media = 'all';
  }

  if (stylesheet) {
    if (stylesheet.sheet) {
      activateStylesheet();
    } else {
      stylesheet.addEventListener('load', activateStylesheet, { once: true });
      window.setTimeout(activateStylesheet, 4500);
    }
  }

  function closePreferencesDialog() {
    var closeButton = document.getElementById('shopify-pc__prefs__header-close');
    if (closeButton) closeButton.click();
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'shopify-pc__prefs__overlay') {
      closePreferencesDialog();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.getElementById('shopify-pc__prefs__dialog')) {
      closePreferencesDialog();
    }
  });
})();
